import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Spinkit} from 'ng-http-loader';
import {MenuService} from './pages/services/menu.service';
import {HeaderService} from './pages/services/header.service';
import {Subscription} from 'rxjs/Subscription';
import {NavigationEnd, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PASSWORD, PasswordPolicy} from "./pages/components/forms/form-validation";
import {
  CHANGE_PASSWORD,
  GET_PWD_STATUS,
  LOG_OUT_URL,
  WARNING_MSG ,
    SMS_LS_PREPAID_ENTERPRISE_PRESENT_KEY,
  SMS_LS_INTERNATIONAL_FEED_STATUS_KEY,
  // SAVE_USER_AGENT_DETAILS ,
  UPDATE_USER_AGENT_DETAILS,
  GET_TWOFA_STATUS,
  GET_PROFILE_INFO,
  CHECK_SUBUSER,
  CHECK_SUBUSER_LOGIN,
} from "./config";
import {ApiService} from "./pages/services/api.service";
import {environment} from "../environments/environment";
import { Globals } from "./pages/services/globals";
// import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {DataService} from './pages/services/data.service';
import { ReportingPasswordService } from './pages/services/reporting-password.service';
import { SubSink } from 'subsink';
import { TwoFactorAuthService } from './services/two-factor-auth.service';
import { take } from 'rxjs/operators';
import { PermissionService } from './services/permission.service';
import { AuthService } from './services/auth.service';
declare let ga: Function;
declare var setSmartechEnable;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  smartechEnable: boolean;
  public spinkit = Spinkit;
  currentYear = new Date().getFullYear();
  title = 'app';
  dataserviceSubscription: Subscription;
  menuSubscription: Subscription;
  headerSubscription: Subscription;
  showMenu = false;
  showHeader = false;
  headerNotifications : any;
  popRef: NgbActiveModal;
  @ViewChild('changePwdPopup', {static: true}) changePwdPopup;
  @ViewChild('announcePopup', {static: true} ) announcePopup;
  verifyChangePwdForm: UntypedFormGroup;
  passwordDataObject = [];
  passwordData = '';
  passwordFlag = 0;
  passwordPolicy: PasswordPolicy;
  passwordType: string;
  passwordMsg: string;
  config = {
    keyboard: false,
    backdrop: false
  };
  ipAddress : any;
  userAgent : any;
  newUI : boolean;
  newUIClass : string;
  setSmartechEnable = setSmartechEnable;
  filteredUrlPatterns = ['domain_action', 'get_profile_info', 'list_domains',
    'signleReportDetails', 'setup', 'get_whatsapp_template_insights'];
  private subs = new SubSink();
  private isTwoFactorBootstrapped = false;

  constructor(private menuService: MenuService,
              private headerService: HeaderService,
              private _router: Router,
              private modalService: NgbModal,
              private apiService: ApiService,
              private global : Globals,
              private http : HttpClient,
              private dataservice : DataService,
              private twoFactorAuthService: TwoFactorAuthService,
              private permissionService: PermissionService,
              private authService: AuthService,
              private reportingPasswordService: ReportingPasswordService ) {

            this.menuSubscription = menuService.showMenu$.subscribe(bool => this.showMenu = bool);
            this.headerSubscription = headerService.showHeader$.subscribe(bool => this.showHeader = bool);
            this.headerService.setLogoSubTitle('emailapi'); // to set product type fetch this from api call
            this.dataserviceSubscription = dataservice.newUI$.subscribe(bool => this.newUI = bool);
            this.dataserviceSubscription = dataservice.newUIClass$.subscribe(string => this.newUIClass = string);
  }

  ngOnInit() {

    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem("whatsappToken");
      // Clear prepaid enterprise presence cache on hard reload/tab close
      localStorage.removeItem(SMS_LS_PREPAID_ENTERPRISE_PRESENT_KEY);
      // Clear international feed status cache on hard reload/tab close
      localStorage.removeItem(SMS_LS_INTERNATIONAL_FEED_STATUS_KEY);
    });
    // this.checkForTwoFA( ); // commenting for testing new onboarding flow
    this.setSmartechEnable;
    this.apiService.getDomainCardStatus();
    this.apiService.fetchWithoutActivatUserDetails();
    this.passwordPolicy = new PasswordPolicy();
    this.getPwdStatus();
    console.log("-->#url",this._router.url);
    // console.log("-->#url",this._router.url);
    // override the route reuse strategy
    this._router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this._router.events.subscribe((evt) => {
      // trick the Router into believing it's last link wasn't previously loaded
      if (evt instanceof NavigationEnd) {
        this.dataservice.activePath(evt.urlAfterRedirects);
        this._router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);

        this.global.triggerPageChange( );  // Appcues trigger page change
        ga('set', 'page', evt.urlAfterRedirects);
        console.log("IN GA ==================== ");
        console.log("--->",evt.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });

    this.setInitialClientProfile();

    if(!this.setSmartechEnable){
      //console.log(this.setSmartechEnable, 'app component login call...');
      this.apiService.fetchWithoutActivatUserDetails();
      // Load permissions after token is generated
      this.loadUserPermissions();
      } else {
      this.ceeFetchLogin().then(() => {
        // Header/menu are not mounted in Smartech mode; replicate main-menu account bootstrap so
        // globals, AuthService, and MenuService stay consistent for deep links (e.g. billing).
        this.bootstrapSmartechAccountShell();
        // Load permissions after token is generated
        this.loadUserPermissions();
      });
      }
  }

  /**
   * Subset of new-main-menu init() needed when the shell (header/menu) is not rendered (Smartech iframe).
   */
  private bootstrapSmartechAccountShell(): void {
    this.apiService.get(CHECK_SUBUSER_LOGIN).subscribe(
      (result) => {
        if (String(result['status']).toLowerCase() === 'success' && result['data'] != null) {
          const isSubuser = !!(result['data']['is_subuser'] || result['data']['subuser']);
          this.authService.setSubUserState(isSubuser);
        }
      }
    );

    this.apiService.post(CHECK_SUBUSER, '').subscribe((result) => {
      if (String(result['status']).toLowerCase() !== 'success') {
        return;
      }
      this.dataservice.checkSubuser(result);
      if (result['data']['subaccount']) {
        this.authService.setMasterState('subaccount');
        sessionStorage.setItem('loginUserAccountType', 'subaccount');
      } else {
        this.authService.setMasterState('master');
        sessionStorage.setItem('loginUserAccountType', 'master');
      }
      if (result['data']['sub_user'] > 0 || result['data']['subaccount'] > 0) {
        this.menuService.setSubUserValue(true);
        if (result['data']['parent'] !== '' || result['data']['parent'] !== null) {
          this.menuService.setParentUserName(result['data']['parent']);
        } else {
          this.menuService.setParentUserName('');
        }
      } else {
        this.menuService.setSubUserValue(false);
        this.menuService.setParentUserName('');
      }
    });

    this.menuService.refreshCredits();
  }
  

  ngOnDestroy(): void {
    this.menuSubscription.unsubscribe();
    this.headerSubscription.unsubscribe();
    this.subs.unsubscribe();
  }

  getPwdStatus() {

    document.body.classList.add('new-theme');
    this.subs.sink = this.apiService.get(GET_PWD_STATUS)
      .subscribe(result => {
          if (result['status'] === 'success') {

	          this.dataservice.newUI$ = result['data']['newui'];
            this.dataservice.setHashEnabled((result["data"]["hash_enabled"]));
            const defaultProduct = result['data']['default_product'];
            this.headerService.setLogoSubTitle(
              defaultProduct != null && String(defaultProduct).trim() !== '' ? String(defaultProduct).trim() : 'emailapi'
            );

            // smartech enable check for the WA redirection ( hide header and menu section )
            this.smartechEnable = result['data']['smartech'];
            this.global.setCEE(this.smartechEnable);
            if(result['data']['newui'] === true){
                // this.newUI = true;
                // this.newUIClass = 'page-body';
                // this.dataservice.newUI(result['data']['newui']);
                // this.dataservice.newUIClass('page-body');

            }else{
                this.newUI = false;
                this.newUIClass = '';
                document.body.classList.remove('new-theme');
            }
            if (result['data']['status'] === 1 && (this.smartechEnable == false)) {
              this.open(this.changePwdPopup);
            }
	          else if (result['data']['data_policy'] === 1 && (this.smartechEnable == false)) {
              this.open(this.announcePopup);
            }
          // Check if running on localhost or local environment, then call skipSetPassword
          if (window && window.location && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.'))) {
            this.skipSetPassword();
          }
          }
        }, error => {
          // this.passwordType = 'warning';
          // this.passwordMsg = WARNING_MSG;
        }
      );

  }

  /**
   * Set New Login passwordbna
   * @param old_pass
   * @param new_pass
   */
  setPassword(old_pass, new_pass) {
    this.subs.sink = this.twoFactorAuthService
      .ensureTwoFactorValid('change_password')
      .pipe(take(1))
      .subscribe((isAllowed) => {
        if (!isAllowed) {
          return;
        }

        this.subs.sink = this.apiService.post(CHANGE_PASSWORD, {
          'old_pass': encodeURIComponent(window.btoa(old_pass)),
          'new_pass': encodeURIComponent(window.btoa(new_pass))
        })
          .subscribe(result => {
              console.log(result);
              if (result['status'] === 'success') {
                this.passwordType = 'info';
                this.passwordMsg = result['message'];
                this.apiService.cleanUpLocalStorageForSMS();
                window.location.href = `${environment.api_url}${ LOG_OUT_URL}`;
              } else {
                this.passwordType = 'danger';
                this.passwordMsg = result['error_info']['message'];
              }
            }, error => {
              this.passwordType = 'warning';
              this.passwordMsg = WARNING_MSG;
            }
          );
      });
  }

  open(content) {
    this.verifyChangePwdForm = new UntypedFormGroup({
      old_pass: new UntypedFormControl('', [Validators.required]),
      new_pass: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(PASSWORD)
      ]),
      confirm_pass: new UntypedFormControl('', [
        Validators.required,
        // Validators.pattern(PASSWORD)
      ]),
    });

    this.popRef = this.modalService.open(content, this.config);
  }

  /**
   * This function is used to validate password polciy
   * @param ev
   */
  checkPassword(ev) {
    this.passwordDataObject = this.passwordPolicy.validatePassword(ev.target.value);
    this.passwordData = this.passwordDataObject[0];
    this.passwordFlag = this.passwordDataObject[1];
  }
  readAnnouncement(){
    this.subs.sink = this.apiService.get(UPDATE_USER_AGENT_DETAILS).subscribe(result => {
          this.popRef.close(this.announcePopup);
        }
      );
    // this.userAgent = window.navigator.userAgent;
    // this.getIPAddress();

  }

  skipSetPassword() {
    this.popRef.close(this.changePwdPopup);
    // this.newUI = true;
    // this.newUIClass = 'page-body';
    // document.body.classList.add('new-theme');
  }
  // getIPAddress()
  // {
  //   this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
  //     this.ipAddress = res.ip;
  //     this.saveUserAgentDetails();
  //   });
  // }
  // saveUserAgentDetails(){
  //   this.apiService.post(SAVE_USER_AGENT_DETAILS, {
  //     'ip': this.ipAddress,
  //     'agent': this.userAgent
  //   }).subscribe(result => {
  //         this.popRef.close(this.announcePopup);
  //       }
  //     );
  // }

  checkForTwoFA() {
    this.subs.sink = this.apiService.get(GET_TWOFA_STATUS).subscribe(result => {
      if(result['data']['super_status'] == 1 && result['data']['status'] == 0) {
        this._router.navigate(['/profile/details']);
        // this.menuService.hideMenu();
      }
    })
  }


  setInitialClientProfile(){
    /** Fetch profile data on load */
    this.subs.sink = this.dataservice.profileInfo$.subscribe(message => {
      if (this.dataservice.isEmpty(message)) {
        this.apiService.get(GET_PROFILE_INFO).subscribe(result => {
          if (result['status'] === 'success') {
            // set client details in globals for Appcues
            let data = result.data;
            this.global.setClientProfile(data);
            this.dataservice.profileInfo(result);

            // Bootstrap two-factor auth status only once, after an authenticated call succeeds (token/session available)
            if (!this.isTwoFactorBootstrapped) {
              this.isTwoFactorBootstrapped = true;
            this.subs.sink = this.twoFactorAuthService.loadFromServer().subscribe();
            }
            this.reportingPasswordService.checkReportingPasswordSet();
          }
        });
      } else {
        if (message['status'] === 'success') {
          // set client details in global for Appcues
          let data = message.data;
          this.global.setClientProfile(data);

          // Ensure bootstrap is triggered even if profile was already cached in DataService
          if (!this.isTwoFactorBootstrapped) {
            this.isTwoFactorBootstrapped = true;
          this.subs.sink = this.twoFactorAuthService.loadFromServer().subscribe();
          }
          this.reportingPasswordService.checkReportingPasswordSet();
        }
      }
    });

  }

  async ceeFetchLogin() {
    //console.log(this.setSmartechEnable, 'asyn.... app component login call...');
    let loginApi = await this.apiService.fetchWithoutActivatUserDetails();
  }

  /**
   * Load user permissions after token is generated
   */
  loadUserPermissions(): void {
    this.subs.sink = this.permissionService.loadPermissions().subscribe({
      next: (response: any) => {
        if(response['status'] === 0) {
          this.apiService.redirectToLogout(LOG_OUT_URL);
        }
        this.permissionService.processPermissionsResponse(response);
      },
      error: (error) => {
        console.error('Error loading user permissions:', error);
        // Set default permissions to prevent crashes
        this.permissionService.setUserPermissions({});
      }
    });
  }

}
